import { Theme } from '@material-ui/core/styles';
import { CreateCSSProperties, createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { HeaderIcon } from '@/layout/components';
import { Status } from '@/layout/components/HeaderIcon';
import MainLayout, { MainLayoutProps } from '@/layout/MainLayout';
import { makeSelectIsMobileView } from '@/model/global/selectors';

const useStyles = makeStyles((theme: Theme) => {
  const baseContainer: CreateCSSProperties = {
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  };
  const mainBox: CreateCSSProperties = baseContainer;
  return createStyles({
    logoutBox: {
      width: '100%',
      position: 'absolute',
      right: 0,
      top: 0,
    },
    container: {
      paddingTop: 68,
    },
    mainBox: {
      ...mainBox,
      width: theme.MainContainer.width,
    },
    mainBoxMobile: {
      ...mainBox,
      marginTop: 48,
      paddingTop: 42,
      backgroundColor: theme.colors.primaryBackground,
      color: theme.colors.primary,
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
      maxWidth: 'unset',
    },
  });
});

const selectIsMobile = makeSelectIsMobileView();

export interface StatusLayoutProps extends Omit<MainLayoutProps, 'content' | 'container'> {
  status: Status;
  height?: number | 'unset';
  classnames?: {
    contentForm?: string;
  };
}

const StatusLayout: React.FC<StatusLayoutProps> = ({ header, status, classnames, ...props }: StatusLayoutProps) => {
  const classes = useStyles();
  const isMobile = useSelector(selectIsMobile);
  return (
    <MainLayout
      content={{
        prefix: isMobile && <HeaderIcon status={status} />,
        className: !isMobile ? classes.mainBox : classes.mainBoxMobile,
        contentClassName: classnames?.contentForm,
      }}
      header={{
        ...header,
        title: isMobile && header?.title,
        noLogo: true,
        className: clsx(header?.className, !isMobile && classes.logoutBox),
      }}
      container={{
        className: !isMobile ? classes.container : undefined,
        prefix: !isMobile && <HeaderIcon status={status} />,
      }}
      {...props}
    />
  );
};

export default StatusLayout;
